module.exports = __webpack_public_path__ + "static/img/04.a144fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/04.png
// module id = 6zAE
// module chunks = 1